<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content tac">
				<h2 class="headline_m">
					{{ $t('rtr_personal-request-receive.title1') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-request-receive.text1') }}<br />{{
						$t('rtr_personal-request-receive.text2')
					}}
				</p>
				<div class="button_area">
					<button class="button_bg_red mr_10" @click="toLogin">
						{{ $t('button.cryptocurrency_request') }}
					</button>
					<button class="button_bg_black" @click="notYet">
						{{ $t('button.down') }}
					</button>
				</div>
			</div>
		</div>
		<section
			class="content_area background d_flex justify_center align_items_center"
		>
			<div>
				<h2 class="title_l fc_white mb_20">
					{{ $t('rtr_personal-request-receive.title2') }}
				</h2>
				<p class="body_m fc_gray">
					{{ $t('rtr_personal-request-receive.text3') }}<br />
					{{ $t('rtr_personal-request-receive.text4') }}
				</p>
			</div>
		</section>

		<section>
			<div class="content_area tac">
				<div class="detail_area">
					<div class="detail">
						<h2 class="headline_s">
							{{ $t('rtr_personal-request-receive.title3') }}<br />
							{{ $t('rtr_personal-request-receive.title4') }}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/receive_03.png" alt="" />
						</div>
						<div class="text">
							<p class="body_m">
								{{ $t('rtr_personal-request-receive.text5') }}<br />
								{{ $t('rtr_personal-request-receive.text6') }}
							</p>
						</div>
					</div>
				</div>
				<div class="detail_area">
					<div class="detail">
						<h2 class="headline_s">
							{{ $t('rtr_personal-request-receive.title5') }}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/receive_04.png" alt="" />
						</div>
						<div>
							<p class="body_m mb_50">
								{{ $t('rtr_personal-request-receive.text7') }}<br />{{
									$t('rtr_personal-request-receive.text8')
								}}
							</p>
						</div>
					</div>
				</div>
				<div class="sub_m_bottom mb_50 fs_18">
					<p class="title_m ma_0 fc_white">
						{{ $t('rtr_personal-request-receive.text9') }}<br />
						{{ $t('rtr_personal-request-receive.text10') }}
					</p>
				</div>
				<div class="detail_area">
					<div class="detail">
						<h2 class="headline_s">
							{{ $t('rtr_personal-request-receive.title8') }}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/receive_05.png" alt="" />
						</div>
						<div class="text">
							<p class="body_m">
								{{ $t('rtr_personal-request-receive.text11') }}<br />
								{{ $t('rtr_personal-request-receive.text12') }}
							</p>
							<router-link to class="m_link_type_02" @click="notYet">
								{{ $t('rtr_personal-request-receive.text13') }}
								<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';
export default {
	name: 'Receive.m',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>

<style scoped></style>
